@if (visitType) {
  <div class="discover-pathway-container">
    <div class="back-container" (click)="back()">
      <span nz-icon nzType="arrow-left" nzTheme="outline"></span><span>{{ 'discoverPathway.back' | translate }}</span>
    </div>
    <div class="content-container">
      <div class="header-container">
        <div>
          <h2>{{ 'discoverPathway.' + visitType + '.title' | translate }}</h2>
          <p>{{ 'discoverPathway.' + visitType + '.subtitle' | translate }}</p>
        </div>
        <ds-button [text]="'buttons.buy' | translate" [width]="'small'" [iconRight]="'/public/assets/images/shoppingCartWhite.svg'" (click)="buy()"></ds-button>
      </div>
      <img [src]="'/public/assets/images/' + visitType + '.svg'" [alt]="visitType + 'image'" />
      <div class="details-container">
        <strong>{{ 'discoverPathway.details' | translate }}</strong>
        <nz-divider></nz-divider>
        @if (!('discoverPathway.' + visitType + '.info_content' | translate).includes(visitType)) {
          <div class="info-container">
            <span>{{ 'discoverPathway.info' | translate }}</span>
            <p>{{ 'discoverPathway.' + visitType + '.info_content' | translate }}</p>
          </div>
        }

        @if (!('discoverPathway.' + visitType + '.included_content' | translate).includes(visitType)) {
          <div class="included-container">
            <span>{{ 'discoverPathway.included' | translate }}</span>
            <p>{{ 'discoverPathway.' + visitType + '.included_content' | translate }}</p>
          </div>
        }
      </div>
      <div class="price-container">
        <span>
          {{ 'discoverPathway.price' | translate }} <span>{{ priceInfo?.lordo + ' €' }}</span>
        </span>
        <ds-button [text]="'buttons.buy' | translate" [width]="'small'" [iconRight]="'/public/assets/images/shoppingCartWhite.svg'" (click)="buy()"></ds-button>
      </div>
    </div>
  </div>
}

